import home from "./home";
import payment from "./payment";
import transaction from "./transaction"

const Routes = [...home, ...transaction, ...payment];

export default Routes;
